import React from 'react'
import { ThemeProvider } from 'styled-components'

import textStyles from './textStyles'
import colors from './colors'
import DefaultStyles from './DefaultStyles'

import './fonts.css'
import './normalize.css'
import './global.css'

const themeExtended = {
  ...colors,
  ...textStyles,
}
const FigmaProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => (
  <ThemeProvider theme={themeExtended}>
    <DefaultStyles>{children}</DefaultStyles>
  </ThemeProvider>
)

export default FigmaProvider
